import React from 'react';

/** @import {VerticalContextValue} from 'lib/types/verticalContext.js' */

export const VerticalContext = React.createContext(/** @type {VerticalContextValue} */ ('news'));
